import { inject } from "@angular/core";
import { AuthService } from "../../features/auth/services/auth.service";
import { CanActivateFn, Router } from "@angular/router";

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if(authService.isLoggedIn()){
        return true;
    }

    router.navigate(['/auth/login']);
    return false;
}
